import {UserContact, UserContactPost} from "../../../types/domain.ts";
import {baseRequestService} from "../../base.ts";

export const usersUserIdContactsPost = (userId: number, data: UserContactPost) =>
    baseRequestService<UserContact>({
        url: `/users/${userId}/contacts`,
        method: 'POST',
        data
    })